<div
  id="recover-registry"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start"
>
  <app-wellcome />
  <div
    id="recover-registry-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <div id="recover-registry-form">
      <div class="logo" fxHide.gt-xs></div>

      <div class="title">RECUPERAR REGISTRO</div>
      <div *ngIf="isValidate">
        <form
          name="recoverForm"
          autocomplete="off"
          *ngIf="recoverForm"
          [formGroup]="recoverForm"
          (submit)="showConfirmRegister()"
          novalidate
        >
          <mat-form-field appearance="outline" class="mf-first-name">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              autocomplete="firstName"
              toUpperCase
              formControlName="firstName"
              required
              (blur)="checkName('firstName')"
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getNombreErrorTooltip()"
              [ngClass]="{ 'error-icon': hasNombreError() }"
              >account_circle</mat-icon
            >
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Apellidos</mat-label>
            <input
              matInput
              autocomplete="lastName"
              toUpperCase
              formControlName="lastName"
              required
              (blur)="checkName('lastName')"
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getApellidoErrorTooltip()"
              [ngClass]="{ 'error-icon': hasApellidoError() }"
              >account_circle</mat-icon
            >
          </mat-form-field>
          <div>Pin de seguridad:</div>
          <app-pin-code (pinCodeEmitter)="processPin($event)" />
          <div class="siguiente" fxLayout="row" fxLayoutAlign="center">
            <button
              *ngIf="!recoverForm.valid"
              mat-raised-button
              color="warn"
              class="siguiente"
              (click)="exit($event)"
            >
              Salir
            </button>
            <button
              [disabled]="isLoading"
              *ngIf="recoverForm.valid"
              mat-raised-button
              color="primary"
              class="siguiente"
            >
              <span *ngIf="!isLoading">Siguiente</span>
              <div class="loadingComponent" *ngIf="isLoading">
                <app-loading [isLoading]="isLoading" />
              </div>
            </button>
          </div>
        </form>
      </div>
      <div *ngIf="isRegisterConfirm" class="register-confirm">
        <h4>
          Te hemos enviado un enlace de registro al siguiente correo electronico
        </h4>
        <h4>{{ email }}</h4>
        <div *ngIf="!isEmailRegistered">
          <a (click)="sendEmail()">No has recibido enlace, volver a enviarlo</a>
          <br />
          <br />
          <a (click)="viewChangeEmail()"
            >Cambiar dirección de correo electronico</a
          >
        </div>
        <form
          name="emailRecoverForm"
          *ngIf="isShowChangeEmail && emailRecoverForm"
          [formGroup]="emailRecoverForm"
          (submit)="onSubmitChangeEmail()"
        >
          <mat-form-field appearance="outline">
            <mat-label>Nuevo email</mat-label>
            <input
              matInput
              autocomplete="email"
              formControlName="email"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getEmailErrorTooltip()"
              [ngClass]="{ 'error-icon': hasEmailError() }"
              >mail</mat-icon
            >
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            class="submit-button"
            aria-label="Cambiar"
            [disabled]="emailRecoverForm.invalid || isLoading"
          >
            <span *ngIf="!isLoading">CAMBIAR</span>
            <div class="loadingComponent" *ngIf="isLoading">
              <app-loading [isLoading]="isLoading" />
            </div>
          </button>
        </form>
      </div>
    </div>
    <div class="copy">Nubyy 2019, Todos los derechos reservados.</div>
  </div>
</div>
